<template>
    <div class="col-12 mb-4">
      <SoftButton @click="goBack()" type="button" color="primary"> 
        <i
        class="fas fa-arrow-left text-sm ms-1"
        aria-hidden="true"
        ></i> &nbsp;&nbsp; Back to Menu
      </SoftButton>
    </div>
    <div class="col-12">
      <div class="card mb-4" style="padding: 15px;">
        <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
          <div style="min-width: 310px;
            max-width: 350px; display: flex; align-items: center; gap: 5px;">
            <b>Team</b>
            <Multiselect 
            style="border-radius: 0.5rem; "
              @change="sendFilter(1, '')"
              v-model="collections.value"
              v-bind="collections"
              placeholder="Select a team"
            ></Multiselect>
            <!--<SoftCheckbox
              class="font-weight-light"
              :checked="checked"
              @change="setAsDefault(collections.value)"
            >
              Use as default
            </SoftCheckbox>-->
          </div>
          <soft-button style="display: flex; gap: 5px;" @click="reloadEmails()" color="success" size="md" variant="outline">
            <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Refresh
          </soft-button>
        </div>
      </div>
    </div>
    <soft-alert v-show="notImported === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>There was a problem</strong> Emails couldn't been imported with these credentials, try again!
    </soft-alert>
    <soft-alert v-show="imported === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Imported correctly</strong> Each email takes up to 5 seconds to be processed, refresh the page to update the entries.
    </soft-alert>
    <soft-alert v-show="notReceived === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>Error</strong> Mail received field must not be empty
    </soft-alert>
    <soft-alert v-show="notSent === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>Error</strong> Mail sent field must not be empty
    </soft-alert>
    <soft-alert v-show="mailDeleted === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Success</strong> Mail deleted!
    </soft-alert>
    <soft-alert v-show="mailNotDeleted === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>There was a problem</strong> Mail couldn't be deleted, try again!
    </soft-alert>
    <soft-alert v-show="newEmailCorrect === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Success</strong> Mail created!
    </soft-alert>
    <soft-alert v-show="outlookCsvCorrect === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Success</strong> Data will be processed email by email with 1 second latency between each email. To see the results reload the page and filter by the specific team.
    </soft-alert>
    <!--<soft-alert v-show="outlookCsvError === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>Error</strong> Data was not inserted correctly. Checked if the CSV format is correct and if the email account is the same as the one from which the data was exported.
    </soft-alert>-->
    <soft-alert v-show="outlookCsvError === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>{{ outlookErrorMessage }}</strong>
    </soft-alert>
    <soft-alert v-show="newEmailNotCreated === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>There was a problem</strong> Mail couldn't be created, try again!
    </soft-alert>
    <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
      <strong> {{ responseMessage }} </strong>
    </soft-alert>

  <div class="card mb-4">
    <div class="card-header pb-0 mb-4">
      <div id="menu" style="display: flex; justify-content: space-between; align-items: center; gap: 10px;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <div class="input-group">
            <span class="input-group-text text-body"
              ><i class="fas fa-search" aria-hidden="true"></i
            ></span>
            
            <textarea
              @keydown.enter.prevent="preventMoving"
              type="text"
              rows="1"
              id="buscador"
              @keyup.enter="getDB(1, inputValue)"
              v-model="inputValue"
              class="form-control"
              placeholder="Type and hit 'enter'"
            />
          </div>
          
        </div>
        
        <div style="display: flex; align-items: center; gap: 10px;">
          <!--<SoftButton color="default" data-bs-toggle="modal" data-bs-target="#newMailCSV">Import csv</SoftButton>
          <a style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#importFromGmail">
            <img src="../../assets/img/btn_google_signin_light_normal_web.png" />
          </a>-->
          <a @click="registrarClick('outlook')" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#importFromOutlook">
            <img src="../../assets/img/sing-in-microsoft.png" />
          </a>
          <SoftButton @click="registrarClick('email')" data-bs-toggle="modal" data-bs-target="#newMail">New mail</SoftButton>
        </div>
      </div>
    </div>
    <div style="height: 400px; display: flex; align-items: center; justify-content: center;" v-if="loading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>
    <div v-else>
      <div class="card-body px-0 pt-0 pb-2">
        <div v-show="datos.length !== 0" class="table-responsive p-0" style="max-height: 720px; overflow-y: scroll; height: 400px; padding: 15px !important;">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <!--<th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Date
                </th>-->
                <th scope="col"
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >
                  Received
                </th>
                <th scope="col"
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Sent
                </th>
                <th scope="col"
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in datos.emails" v-bind:key="row">
                <!--<td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"
                    >23/04/18</span
                  >
                </td>-->
                <td style="width: 40%;">
                      <div :id="'received'+row.token.replaceAll('-', '')" :title="row.email_received"
                        class="email text-xs text-secondary mb-0">
                        {{ row.email_received }}
                      </div>
                      <a :onload="mostrarBoton('received'+row.token.replaceAll('-', ''),'botonReceived'+row.token.replaceAll('-', ''))"
                        @click="mostrarTodo('received'+row.token.replaceAll('-', ''))"
                       style="display: none; color: #cb0c9f; cursor: pointer;" 
                       :id="'botonReceived'+row.token.replaceAll('-', '')" class="hover">Read entire email</a>
                </td>
                <td style="width: 40%;">
                    <div :id="'sent'+row.token.replaceAll('-', '')" :title="row.email_sended" 
                      class="email text-xs text-secondary mb-0">
                      {{ row.email_sended }}
                    </div>
                    <a :onload="mostrarBoton('sent'+row.token.replaceAll('-', ''), 'botonSent'+row.token.replaceAll('-', ''))" 
                    @click="mostrarTodo('sent'+row.token.replaceAll('-', ''))"
                    style="display: none; color: #cb0c9f; cursor: pointer;" 
                    :id="'botonSent'+row.token.replaceAll('-', '')" 
                     class="hover">Read entire email</a>
                </td>
                <td style="width: 20%;" class="align-middle text-center">
                  <a
                    @click="openDeleteModal(row.token)" data-bs-toggle="modal" data-bs-target="#idDeleteMail"
                    class="btn text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit user"
                    >
                      Delete
                    </a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-show="datos.length === 0" style="display: grid; justify-items: center;">
          <img style="width: 50%; padding-top: 50px;" src="../../assets/img/New-message-pana.png" /> 
          <p class="text-2xl text-center sm:text-4xl font-bold text-darkblue-500 mb-2">
            Ups!... no results found
          </p>
          <p class="text-xl text-gray-700">Please try another search</p>
        </div>
      </div>
      <div v-show="datos.length !== 0" class="card-footer">
        <soft-pagination color="success" style="display: flex; justify-content: center; margin: 0; align-items: center; padding: 15px 0px 0px;">
          <soft-pagination-item v-show="pages !== 1" @click="prev()" prev />
          <soft-pagination-item @click="goToOne()" label="1" />
          <soft-pagination-item v-show="pages > 2" label="..." />
          <soft-pagination-item v-show="pages !== 1 && pages !== 0" @click="goToLast()" :label="pages.toString()" />
          <soft-pagination-item v-show="pages !== 1" @click="next()" next />
          <span>Page {{ page }}</span>
        </soft-pagination>
      </div>
    </div>
    
    <!-- Modal New Mail-->
    <div class="modal fade" data-bs-backdrop="static" id="newMail" tabindex="-1" aria-labelledby="newMailModal" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="newMailModal">New mail</h5>
            
          </div>
          <div class="modal-body">
            <label>Received</label>
            <textarea
              v-model="received"
              id="received"
              class="form-control"
              rows="5"
              placeholder="Mail received"
            ></textarea>
            <label>Response</label>
            <textarea
              v-model="response"
              id="response"
              class="form-control"
              rows="5"
              placeholder="Mail sent"
            ></textarea>
            <!--<select id="selectorTeamNewMail" class="btn" style="margin: 0px">
              <option v-for="(collection, index) of collections" :key="index" 
              :label="collection.name" :value="collection.token"></option>
            </select>-->
          </div>
          <div class="modal-footer">
            <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton @click="newEmail()" data-bs-dismiss="modal">Save changes</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Delete EMail-->
    <div class="modal fade" data-bs-backdrop="static" id="idDeleteMail" tabindex="-1" aria-labelledby="deleteMailLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Delete mail</h5>
            
          </div>
          <div class="modal-body">
            Your are about to delete a mail
          </div>
          <div class="modal-footer">
            <SoftButton color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton color="danger" @click="deleteMail()" data-bs-dismiss="modal">Delete</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Upload csv-->
    <div class="modal fade" data-bs-backdrop="static" id="newMailCSV" tabindex="-1" aria-labelledby="newMailCSVModal" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="newMailModal">New mail</h5>
            
          </div>
          <div class="modal-body">
            <label>Upload your CSV file</label>
          <br />
            <div style="display: flex; align-items: baseline;">
              <a class="btn btn-success" onclick="document.getElementById('csvFile1').click()">Upload CSV file</a>
              <span>&nbsp;&nbsp;{{ file }}</span>
            </div>
            <input style="visibility:hidden;" @change="uploadCSV($event.target.files)" type="file" id="csvFile1" accept=".csv" />
          </div>
          <div class="modal-footer">
            <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton @click="newEmailCSV()" data-bs-dismiss="modal">Save changes</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <!--MODAL anterior a los otros dos de outlook-->
    <div class="modal fade" data-bs-backdrop="static" id="importFromOutlook" tabindex="-1" aria-labelledby="importFromOutlookModal" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="importFromOutlookModal">Import emails from Outlook</h5>
            
          </div>
          <div class="modal-body">
            <div class="row" style="margin: 0px; display: flex;
              justify-content: space-around;">
              <div class="col-5 card p-3" @click="cerrarModalOutlook('creds')" data-bs-toggle="modal" data-bs-target="#outlookCreds" style="cursor: pointer;">
                <div class="d-flex flex-column h-100" data-bs-toggle="tooltip" data-bs-placement="top" 
                    title="Your credentials are promptly deleted once the import task is completed, ensuring utmost data security and privacy.">
                  <!--<p class="mb-1 pt-2 text-bold">Import using Outlook credentials</p>-->
                  <h5 class="font-weight-bolder">
                    <img width="30" height="30" src="https://img.icons8.com/fluency-systems-filled/48/ms-outlook.png" alt="ms-outlook"/>
                    Log in with Outlook
                  </h5>
                  <p class="mb-5">Import your Outlook emails by securely entering your credentials <sup data-bs-toggle="tooltip" data-bs-placement="top" 
                    title="Your credentials are promptly deleted once the import task is completed, ensuring utmost data security and privacy.">
                    <img 
                    width="10" 
                    height="10" 
                    src="https://img.icons8.com/ios/50/info--v1.png" alt="info--v1"/>
                  </sup> 
                  on our platform. Only external emails are imported, while strictly safeguarding the privacy and confidentiality of your corporate communications.</p>
                  <a class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto" href="javascript:;"> 
                    Connect your account <i class="fas fa-arrow-right text-sm ms-1" aria-hidden="true"></i>
                  </a>
                  
                </div>
              </div>

              <div class="col-5 card p-3" @click="cerrarModalOutlook('csv')" data-bs-toggle="modal" data-bs-target="#outlookCSV" style="cursor: pointer;">
                <div class="d-flex flex-column h-100">
                  <!--<p class="mb-1 pt-2 text-bold">Import using Outlook credentials</p>-->
                  <h5 class="font-weight-bolder">
                    <img width="30" height="30" src="https://img.icons8.com/fluency-systems-filled/48/csv.png" alt="csv"/>
                    Import emails from CSV
                  </h5>
                  <p class="mb-5"> Simply drag and drop the CSV file onto our platform and provide the corresponding email account. Our system will efficiently process the data, ensuring a seamless and secure email importation.</p>
                  <a class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto" href="javascript:;"> 
                    Upload your CSV <i class="fas fa-arrow-right text-sm ms-1" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <SoftButton id="cerrarModalOutlook" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
          </div>
        </div>
      </div>
    </div>

     <!--MODAL anterior gmail-->
     <div class="modal fade" data-bs-backdrop="static" id="importFromGmail" tabindex="-1" aria-labelledby="importFromGmailModal" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="importFromGmailModal">Import emails from Gmail</h5>
            
          </div>
          <div class="modal-body">
            <div class="row" style="margin: 0px; display: flex;
              justify-content: space-around;">
              <div class="col-5 card p-3" @click="googleAuth()" data-bs-dismiss="modal" style="cursor: pointer;">
                <div class="d-flex flex-column h-100" data-bs-toggle="tooltip" data-bs-placement="top" 
                    title="Your credentials are promptly deleted once the import task is completed, ensuring utmost data security and privacy.">
                    <a class="mb-3" @click="googleAuth()" style="cursor: pointer; display: flex; justify-content: center;" data-bs-toggle="modal" data-bs-target="#importFromGmail">
                      <img src="../../assets/img/btn_google_signin_light_normal_web.png" />
                    </a>
                    <p>Import your Gmail emails by securely giving ToMate permissions <sup data-bs-toggle="tooltip" data-bs-placement="top" 
                      title="Your credentials are promptly deleted once the import task is completed, ensuring utmost data security and privacy.">
                      <img 
                      width="10" 
                      height="10" 
                      src="https://img.icons8.com/ios/50/info--v1.png" alt="info--v1"/>
                    </sup> 
                    to access your emails. We are not going to store the permission, and we will only obtain the emails from the previous 500 conversations.</p>
                  
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <SoftButton id="cerrarModalOutlook" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Upload outlook-->
    <div class="modal fade" data-bs-backdrop="static" id="outlookCSV" tabindex="-1" aria-labelledby="outlookCSVModal" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="outlookModal">Upload your Outlook CSV</h5>
            
          </div>
          <div class="modal-body">
            <label>Outlook email account</label>
            <input
              class="form-control"
              v-model="outlookMail"
              placeholder="Outlook email account"
              isRequired="required"
            />
            <br />
            <label>Upload the CSV file exported from your Outlook</label>
            <br />
            <div style="display: flex; align-items: baseline;">
              <a style="display: flex;
                align-items: center;" class="btn" onclick="document.getElementById('csvFile2').click()">
                <i class="ni ni-folder-17"></i>&nbsp;&nbsp;Select CSV file
              </a>
              <span>&nbsp;&nbsp;{{ file }}</span>
            </div>
            <input style="display: none;" @change="uploadCSV($event.target.files)" type="file" id="csvFile2" accept=".csv" />
          </div>
          <div class="modal-footer">
            <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton @click="outlookCSV()" data-bs-dismiss="modal">Save changes</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal credenciales outlook-->
    <div class="modal fade" data-bs-backdrop="static" id="outlookCreds" tabindex="-1" aria-labelledby="outlookCredsModal" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="outlookCredsModal">Fill the form with your Outlook credentials</h5>
            
          </div>
          <div class="modal-body">
            <label>Outlook email account</label>
            <input
              class="form-control"
              v-model="outlookMailCred"
              placeholder="Outlook email account"
              isRequired="required"
            />
            <br />
            <label>Outlook password</label>
            <div>
              <input
                class="form-control"
                type="password"
                v-model="outlookPassword"
                placeholder="Outlook password"
                isRequired="required"
              />
              <i style="float: right;
                left: -7px;
                cursor: pointer;
                margin-top: -25px;
                position: relative;
                font-size: 12px;
                z-index: 2;" @mouseover="showPass" @mouseout="showPass" class="fa fa-eye"></i>
            </div>
            
          </div>
          <div class="modal-footer">
            <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton @click="outlookCredenciales()" data-bs-dismiss="modal">Save changes</SoftButton>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import SoftPaginationItem from '../../components/SoftPaginationItem.vue';
  import SoftPagination from '../../components/SoftPagination.vue';
  import SoftButton from '../../components/SoftButton.vue';
  import SoftAlert from "@/components/SoftAlert.vue";
  import HTFetch from "../../llamadas/HTFetch"
  import Multiselect from '@vueform/multiselect'

  export default {
    name: "emailsDatabase",

    props: {

    },

    watch: {
      
    },
    
    components: {
      SoftPaginationItem,
      SoftPagination,
      SoftButton,
      SoftAlert,
      Multiselect
    },

    data() {
      return {
        showResponseMessage: false,
        responseMessage: "",
        datos: [],
        loading: false,//true,
        loader: false,
        llamada: new HTFetch(),
        importedGmail: false,
        emails: [],
        file: null,
        page: 1,
        pages: 0,
        inputValue: "",
        reset: false,
        response: "",
        received: "",
        notReceived: false,
        notSent: false,
        mailDeleted: false,
        mailNotDeleted: false,
        newEmailCorrect: false,
        newEmailNotCreated: false,
        outlookCsvCorrect: false,
        outlookCsvError: false,
        deleteToken: "",
        base64CSV: "",
        teamSelected: "",
        outlookMail: "",
        outlookMailCred: "",
        outlookPassword: "",
        notImported: false,
        imported: false,
        outlookErrorMessage: "",
        collections: {
          value: [],
          closeOnSelect: true,
          options: [],
          canClear: false,
          canDeselect: false
        },
        interval: null
      };
    },

    mounted() {
      this.llamada.userInfo(this.userInfoRsp.bind(this))
      this.refreshEmails()
    },

    beforeUnmount() {
      // Clear the interval when the component is about to be destroyed
      clearInterval(this.interval);
    },

    methods: {

      reloadEmails() {
        this.loader = true
        setTimeout(() => {
          this.getDB(1, this.inputValue)
        }, 500)
      },

      refreshEmails() {
        
        this.interval = setInterval(
          () => {
            console.log('refresh')
            this.getDB(this.page, this.inputValue)
          }, 1000*30
        )
      },

      userInfoRsp(rsp) {
        if (rsp.status === 401) {
          
          this.llamada.userInfo(this.userInfoRsp.bind(this))
          return
        }

        let collecciones = []
        for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
          collecciones.push({
            "label": Object.keys(rsp.data.collections)[i],
            "value": Object.values(rsp.data.collections)[i]
          })
        }

        localStorage.collections = JSON.stringify(collecciones)

        //this.multipleSelect.options = collecciones
        this.collections.options = collecciones
        this.collections.value = collecciones[0].value

        localStorage.userId = rsp.data.token
      },

      sendFilter(page, query) {
        this.datos = []
        this.inputValue = ""
        this.loading = true
        setTimeout(() => {
          this.getDB(page, query)
        }, 500)
      },

      getDB(page, query) {
        //this.loading = true
        this.page = page
        this.llamada.getDB(page, query, this.collections.value, this.getDBRsp.bind(this))
      },

      getDBRsp(rsp) {

        // Iterar sobre los emails en rsp.data.emails
        if (this.datos.length !== 0) {
          rsp.data.emails.forEach(emailRsp => {
            // Verificar si el token del email actual de rsp.data.emails ya existe en this.datos.emails
            const emailExistente = this.datos.emails.find(emailDatos => emailDatos.token === emailRsp.token);

            // Si el email con ese token no existe en this.datos.emails, lo inyectamos
            if (!emailExistente) {
              this.datos.emails.push({
                token: emailRsp.token,
                email_received: emailRsp.email_received,
                email_sended: emailRsp.email_sended
              });
            }
          });
        } else {
          this.datos = rsp.data
        }
        
        this.pages = rsp.data.pages
        setTimeout(() => {
          this.loading = false
          this.loader = false
        }, 500)

        if (rsp.status === 402) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
        }
      },

      showPass() {
        var input = document.querySelector('#outlookCreds > div > div > div.modal-body > div > input')
        let attributeValue = input.getAttribute('type');

        console.log(attributeValue)

        if (attributeValue == "password") {
          input.setAttribute('type', 'text')
        } else {
          input.setAttribute('type', 'password')
        }
      },

      preventMoving(event){
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      },

      newEmail() {
        
        if (this.received.length === 0) {
          this.notReceived = true

          setTimeout(() => {
            this.notReceived = false
          }, 2000)
          return
        }
        if (this.response.length === 0) {
          this.notSent = true

          setTimeout(() => {
            this.notSent = false
          }, 2000)
          return
        }

        //let team = document.getElementById('selectorTeam')
        if (this.collections.value.length === 0) {
          let colecciones = JSON.parse(localStorage.collections)
          this.collections.value = colecciones[0].token
        }

        let body = {
          'email_received': this.received,
          'email_sended': this.response,
          "collection": this.collections.value
        }

        this.llamada.newEmail(body, this.newEmailRsp.bind(this))

        //mando evento
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "send-simple-email",
            user_id: localStorage.userId
          });
        }

      },

      newEmailRsp(rsp) {
        this.loading = true
        this.datos = []
        
        if (rsp.data.token) {
          this.newEmailCorrect = true

          setTimeout(() => {
            this.newEmailCorrect = false
          }, 2000)

          this.received = ""
          this.response = ""

          this.inputValue = ""
          //let team = document.getElementById('selectorTeam')
          if (this.collections.value.length === 0) {
            let colecciones = JSON.parse(localStorage.collections)
            this.collections.value = colecciones[0].token
          }

          this.getDB(1, '')

        } else {
          this.newEmailNotCreated = true

          setTimeout(() => {
            this.newEmailNotCreated = false
          }, 2000)
        }
        
      },

      openDeleteModal(token) {
        
        this.deleteToken = token
      },

      deleteMail() {
        //let team = document.getElementById('selectorTeam')
        if (this.collections.value.length === 0) {
          let colecciones = JSON.parse(localStorage.collections)
          this.collections.value = colecciones[0].token
        }

        let body = {
          'token': this.deleteToken,
          "collection": this.collections.value
        }

        this.llamada.deleteEmail(body, this.deleteMailRsp.bind(this))
      },

      deleteMailRsp(rsp) {
        if (rsp.data.message === 'Deleted') {
          this.loading = true
          this.datos = []

          this.mailDeleted = true
          this.page = 1
          
          setTimeout(() => {

            this.mailDeleted = false
          }, 2000)
          //let team = document.getElementById('selectorTeam')
          if (this.collections.value.length === 0) {
            let colecciones = JSON.parse(localStorage.collections)
            this.collections.value = colecciones[0].token
          }

          this.getDB(1, '')

        } else {

          this.mailNotDeleted = true

          setTimeout(() => {

            this.mailNotDeleted = false
          }, 2000)
        }
      },

      uploadCSV(file) {
        this.file = file[0].name
        function readFile(imagen, handler) {
            var reader = new FileReader();
            
            reader.onload = () => {
                handler(reader.result);
            }
            reader.onerror = function () {
                alert('There was an error reading the file!');
            }
            reader.readAsDataURL(imagen);
        }

        readFile(file[0], function(s) {
          this.base64CSV = s.replace('data:text/csv;base64,', '')
        }.bind(this))
      },

      newEmailCSV() {
        //let team = document.getElementById('selectorTeam')
        if (this.collections.value.length === 0) {
          let colecciones = JSON.parse(localStorage.collections)
          this.collections.value = colecciones[0].token
        }

        let body = {
          'csv': this.base64CSV,
          "collection": this.collections.value
        }

        this.llamada.newEmailCSV(body, this.newEmailCSVRsp.bind(this))
      },

      newEmailCSVRsp(rsp) {

        this.loading = true
        this.datos = []

        if (rsp.data.message) {
          this.newEmailCorrect = true
          this.base64CSV = ""
          
          setTimeout(() => {
            this.newEmailCorrect = false
          }, 2000)

          this.page = 1
          //let team = document.getElementById('selectorTeam')
          if (this.collections.value.length === 0) {
            let colecciones = JSON.parse(localStorage.collections)
            this.collections.value = colecciones[0].token
          }
          this.getDB(1, '')
        }
      },

      outlookCSV() {
        //let team = document.getElementById('selectorTeam')
        if (this.collections.value.length === 0) {
          let colecciones = JSON.parse(localStorage.collections)
          this.collections.value = colecciones[0].token
        }

        if (this.outlookMail.length === 0) {
          this.outlookCsvError = true

          setTimeout(() => {
            this.outlookCsvError = false
          }, 5000)
          return
        }

        if (!this.outlookMail.includes('@')) {
          this.outlookCsvError = true
          
          setTimeout(() => {
            this.outlookCsvError = false
          }, 5000)
          return
        }

        let body = {
          'csv': this.base64CSV,
          "collection": this.collections.value,
          "email_from": this.outlookMail
        }

        this.llamada.outlookCSV(body, this.outlookCSVRsp.bind(this))

        //mando evento
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "send-email-outlook-csv",
            user_id: localStorage.userId
          });
        }
      },

      outlookCSVRsp(rsp) {

        this.loading = true
        this.datos = []

        if (rsp.status === 200) {
          this.outlookCsvCorrect = true
          this.base64CSV = ""
          this.outlookMail = ""
          
          setTimeout(() => {
            this.outlookCsvCorrect = false
          }, 10000)

          this.page = 1
          //let team = document.getElementById('selectorTeam')
          if (this.collections.value.length === 0) {
            let colecciones = JSON.parse(localStorage.collections)
            this.collections.value = colecciones[0].token
          }

          this.getDB(1, '')

        } else {
          this.outlookCsvError = true
          this.outlookMail = ""

          if ('detail' in rsp.data) {
            this.outlookErrorMessage = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Message' in rsp.data) {
            this.outlookErrorMessage = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('message' in rsp.data) {
            this.outlookErrorMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.outlookErrorMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          setTimeout(() => {
            this.outlookCsvError = false
          }, 10000)
        }
      },

      outlookCredenciales() {

        let body = {
          "user": this.outlookMailCred,
          "password": this.outlookPassword,
          "collection": this.collections.value,
          "restrict_domain": true
        }
        
        this.llamada.outlookCredentials(body, this.outlookCredencialesRsp.bind(this))

        //mando evento
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "send-email-outlook-creds",
            user_id: localStorage.userId
          });
        }
      },

      outlookCredencialesRsp(rsp) {
        console.log(rsp)
        if (rsp.status !== 200) {
          this.notImported = true

          setTimeout(() => {
            this.notImported = false
          }, 3000)
          
        } else {
          this.imported = true

          setTimeout(() => {
            this.imported = false
          }, 10000)
        }
      },

      cerrarModalOutlook(accion) {
        if (accion === 'creds') {
          if (this.$gtm.enabled()) {
            window.dataLayer?.push({
              event: "open-outlook-creds",
              user_id: localStorage.userId
            });
          }
        } else {
          if (this.$gtm.enabled()) {
            window.dataLayer?.push({
              event: "open-outlook-csv",
              user_id: localStorage.userId
            });
          }
        }

        var myModalEl = document.getElementById('cerrarModalOutlook');
        myModalEl.click();
      },

      googleAuth() {

        //guardo la coleccion en ls para enviarla con el token que me mande google
        localStorage.collectionImportGmail = this.collections.value

        // Google's OAuth 2.0 endpoint for requesting an access token
        var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

        // Create <form> element to submit parameters to OAuth 2.0 endpoint.
        var form = document.createElement('form');
        form.setAttribute('method', 'GET'); // Send as a GET request.
        form.setAttribute('action', oauth2Endpoint);

        // Parameters to pass to OAuth 2.0 endpoint.
        var params = {'client_id': '406183576071-ft8c5rmv2rjp43fbseurh4fpkgkop564.apps.googleusercontent.com',
                      'redirect_uri': 'https://app.tomate.ai/database',
                      'response_type': 'token',
                      'scope': 'https://www.googleapis.com/auth/gmail.readonly',
                      'include_granted_scopes': 'true',
                      'state': 'pass-through value'};

        // Add form parameters as hidden input values.
        for (var p in params) {
          var input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', p);
          input.setAttribute('value', params[p]);
          form.appendChild(input);
        }

        // Add form to page and submit it to open the OAuth 2.0 endpoint.
        document.body.appendChild(form);
        form.submit();
      
      },

      goBack() {
        console.log('el error de volver a Database está aqui')
        this.$emit('go-back')
      },

      registrarClick(accion) {
        if (accion === 'outlook') {
          if (this.$gtm.enabled()) { 
            window.dataLayer?.push({
              event: "import-email-outlook",
              user_id: localStorage.userId
            });
          }
        } else {
          if (this.$gtm.enabled()) {
            window.dataLayer?.push({
              event: "import-simple-email",
              user_id: localStorage.userId
            });
          }
        }
      },

      mostrarBoton(idConatiner, idBoton) {
        setTimeout(() => {
          let containerEmail = document.getElementById(idConatiner)
          let boton = document.getElementById(idBoton)
          if (containerEmail.clientHeight === 150) {
            boton.style.display = ""
          }
          
        }, 500)
        
      },

      mostrarTodo(id) {
        let containerEmail = document.getElementById(id)
        console.log(containerEmail)
        containerEmail.style.display = "";
        containerEmail.style.webkitLineClamp = 10000;
      },

      prev() {
        this.loading = true
        this.datos = []
        this.getDB(this.page-1, this.inputValue)
      },

      next() {
        this.loading = true
        this.datos = []
        this.getDB(this.page+1, this.inputValue)
      },

      goToOne() {
        this.loading = true
        this.datos = []
        this.getDB(1, this.inputValue)
      },

      goToLast() {
        this.loading = true
        this.datos = []
        this.getDB(this.pages, this.inputValue)
      }
    }
    
  };
</script>
<style scoped>
  #buscador {
    resize: none;
  }

  table {
    width: 100%;
    table-layout: fixed; /* This ensures that the table's layout is fixed, and column widths are maintained */
  }

  @media (max-width: 700px) {
    #menu {
      flex-direction: column;
    }
  }

  .email {
    white-space: break-spaces; 
    word-break: keep-all; 
    display: -webkit-box;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .hover {
    background: linear-gradient(to right, transparent, white 70%);
    padding: 5px 0;
    border: none;
    font-size: 12px;
  }
</style>